import { BorderRadius, Color, getShadow } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px 120px;
  border: 1px solid ${Color.Grey150};
  border-radius: ${BorderRadius.R12};
  ${getShadow('raisedLight')}
`

export const IllustrationContainer = styled.div`
  /* the shared SVG has ~17% empty space above and below the artwork, so the negative margin pulls the layout in */
  height: 120px;
  margin: -20px 0;

  svg {
    width: auto;
    height: 100%;
  }
`
